module.exports = __webpack_public_path__ + "static/media/3.plotting-graphs@2x.794c69a8.png";